import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';

interface CreatePasswordPageProps {
  email?: string;
  username?: string;
}

const CreatePasswordPage: React.FC<CreatePasswordPageProps> = ({ email = '', username = '' }) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const { login, register } = useAuth();

  const handleContinue = async () => {
    console.log('handleContinue called - SIMPLE TEST');
    
    if (!password.trim()) {
      console.log('Password is empty');
      return;
    }
    
    setLoading(true);
    
    // Basit test - 2 saniye bekle ve ana sayfaya git
    setTimeout(() => {
      console.log('Redirecting to main app...');
      setLoading(false);
      // Ana uygulamaya yönlendirme için App state'ini değiştir
      // Bu sayfanın parent'ına erişemiyoruz, o yüzden window kullan
      window.location.reload();
    }, 2000);
  };

  const handleForgotPassword = () => {
    // Navigate to forgot password
    console.log('Navigate to forgot password');
  };

  const handleBack = () => {
    // Navigate back
    console.log('Navigate back');
  };

  return (
    <div style={styles.container}>
      {/* Status Bar */}
      <div style={styles.statusBar}>
        <span style={styles.time}>9:41</span>
        <div style={styles.statusIcons}>
          <span style={styles.icon}>📶</span>
          <span style={styles.icon}>🔋</span>
        </div>
      </div>

      {/* Header */}
      <div style={styles.header}>
        <button onClick={handleBack} style={styles.backButton}>
          ←
        </button>
        <span style={styles.headerTitle}>Open</span>
        <div style={styles.placeholder}></div>
      </div>

      {/* Main Content */}
      <div style={styles.content}>
        <h1 style={styles.title}>Create a password</h1>
        
        <div style={styles.passwordContainer}>
          <label style={styles.label}>PASSWORD</label>
          <div style={styles.inputContainer}>
            <input
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              style={styles.passwordInput}
            />
            <button
              onClick={() => setShowPassword(!showPassword)}
              style={styles.showButton}
            >
              {showPassword ? 'HIDE' : 'SHOW'}
            </button>
          </div>
          <button
            onClick={handleForgotPassword}
            style={styles.forgotButton}
          >
            Forgot password?
          </button>
        </div>

        <button
          onClick={handleContinue}
          disabled={!password.trim() || loading}
          style={{
            ...styles.continueButton,
            opacity: password.trim() && !loading ? 1 : 0.5,
            cursor: password.trim() && !loading ? 'pointer' : 'not-allowed'
          }}
        >
          {loading ? 'Creating...' : 'Continue →'}
        </button>
      </div>

      {/* Footer */}
      <div style={styles.footer}>
        <span style={styles.footerLeft}>Open</span>
        <span style={styles.footerRight}>curated by Mobbin</span>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    height: '100%',
    backgroundColor: '#000',
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
  },
  statusBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 20px',
    fontSize: '14px',
    fontWeight: '600',
  },
  time: {
    color: '#fff',
  },
  statusIcons: {
    display: 'flex',
    gap: '6px',
    color: '#fff',
  },
  icon: {
    fontSize: '12px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 20px',
  },
  backButton: {
    background: 'none',
    border: 'none',
    color: '#007AFF',
    fontSize: '18px',
    cursor: 'pointer',
    padding: '4px 8px',
  },
  headerTitle: {
    fontSize: '17px',
    fontWeight: '600',
    color: '#fff',
  },
  placeholder: {
    width: '40px',
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '0 20px',
    gap: '40px',
  },
  title: {
    fontSize: '32px',
    fontWeight: '700',
    margin: 0,
    textAlign: 'center',
  },
  passwordContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  label: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#8E8E93',
    letterSpacing: '0.5px',
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #3C3C43',
    paddingBottom: '8px',
  },
  passwordInput: {
    flex: 1,
    background: 'none',
    border: 'none',
    color: '#fff',
    fontSize: '17px',
    outline: 'none',
    padding: '0',
  },
  showButton: {
    background: 'none',
    border: 'none',
    color: '#007AFF',
    fontSize: '15px',
    cursor: 'pointer',
    padding: '4px 8px',
  },
  forgotButton: {
    background: 'none',
    border: 'none',
    color: '#007AFF',
    fontSize: '14px',
    cursor: 'pointer',
    padding: '8px 0',
    textAlign: 'left',
    marginTop: '8px',
  },
  continueButton: {
    backgroundColor: '#2C2C2E',
    color: '#fff',
    border: 'none',
    padding: '16px',
    borderRadius: '8px',
    fontSize: '17px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'opacity 0.3s',
    marginTop: '20px',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px',
    color: '#8E8E93',
    fontSize: '12px',
  },
  footerLeft: {
    fontWeight: '600',
  },
  footerRight: {},
};

export default CreatePasswordPage;
